<gl-base-modal (closeModal)="close()">
  <p class="content">
    {{ 'welcome_api_message' | translate }}
  </p>
</gl-base-modal>
